import z from "zod";

export const CommentSchema = z.object({
  id: z.string(),
  forMember: z.boolean().optional(),
  forBooking: z.boolean().optional(),
  forLocation: z.boolean().optional(),
  forOrganisation: z.boolean().optional(),
  forRoom: z.boolean().optional(),
  bookingId: z.string().optional(),
  memberId: z.string().optional(),
  locationId: z.string().optional(),
  organisationId: z.string().optional(),
  roomId: z.string().optional(),
  authorMemberId: z.string(),
  authorMember: z
    .object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string().email(),
      avatar: z.string().optional(),
    })
    .optional(),
  content: z.string(),
  createdAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
  updatedAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
});

export type Comment = z.infer<typeof CommentSchema>;

export interface CommentFilters {
  entityType?: "member" | "booking" | "location" | "organisation" | "room";
  entityId?: string;
  authorMemberId?: string;
  startDate?: string;
  endDate?: string;
}

export interface CommentSort {
  field: "createdAt" | "updatedAt";
  order: "asc" | "desc";
}
